The request ID.

This is included in the HTTP request as an `X-Request-Id` custom header.
